const ReactNativeFeatureFlags = {
  isLayoutAnimationEnabled: () => true,
  shouldEmitW3CPointerEvents: () => false,
  shouldPressibilityUseW3CPointerEventsForHover: () => false,
  animatedShouldDebounceQueueFlush: () => false,
  animatedShouldUseSingleOp: () => false,
  enableCppComponents: () => false
};
export {
  ReactNativeFeatureFlags
};
//# sourceMappingURL=FeatureFlags.js.map
